import { useRecoilState } from 'recoil';
import { useCallback } from 'react';
import NotificationsAtom from '../../models/recoil/notifications/notifications-atom';
import { UserNotification } from './UserNotification';

const useNotifications = () => {
  const [notifications, setNotifications] = useRecoilState(NotificationsAtom);

  const notify = useCallback((notification: UserNotification) => setNotifications(
    (state) => [...state, notification],
  ), [setNotifications]);

  const removeNotification = useCallback((index: number) => setNotifications(
    (state) => state.filter((item) => item !== state[index]),
  ), [setNotifications]);

  const clearNotifications = useCallback(() => setNotifications([]), [setNotifications]);

  return {
    clearNotifications,
    notifications,
    notify,
    removeNotification,
  };
};

export default useNotifications;
